import { useRoute } from "#vue-router";
import { useNuxtApp } from "#imports";
export const getPathStatus = (path) => {
  const route = useRoute();
  const currentPath = route.path;
  const currentPathWithoutTrailingSlash = currentPath.replace(/\/+$/, "");
  const trimmedPath = path.replace(/\/+$/, "").split("?")[0];
  const currentSlugs = currentPathWithoutTrailingSlash.split("/").filter(Boolean);
  const targetSlugs = trimmedPath.split("/").filter(Boolean);
  const isActive = targetSlugs.every(
    (slug, index) => slug === currentSlugs[index]
  );
  const isActiveExact = isActive && currentPathWithoutTrailingSlash === trimmedPath;
  return { isActive, isActiveExact };
};
export const getPathStatusClasses = (path, exactCheck = false) => {
  const { isActive, isActiveExact } = getPathStatus(path);
  if (exactCheck) {
    return {
      "router-link-active": false,
      "router-link-exact-active": isActiveExact
    };
  }
  return {
    "router-link-active": isActive,
    "router-link-exact-active": isActiveExact
  };
};
export const replaceText = (text, pattern, replacement) => {
  if (!replacement || !pattern) {
    return text;
  }
  return text.replace(pattern, replacement);
};
export const getFileTypeFromFileName = (fileName) => {
  const parts = fileName.split(".");
  if (parts.length < 2) {
    return "";
  }
  return parts[parts.length - 1].toLowerCase();
};
export const parseUrlData = (url) => {
  if (!url) {
    return {
      isPrimaryDomain: false,
      isExtern: false,
      isTel: false,
      isMail: false,
      isProxy: false,
      isDeep: false,
      isQuery: false,
      isError: false,
      isPDF: false,
      href: "",
      parsedUrl: null
    };
  }
  const nuxtApp = useNuxtApp();
  const baseUrl = nuxtApp.$config.public.baseUrl;
  const encodedUrl = encodeURI(url);
  const hostname = new URL(baseUrl).hostname;
  const urlProperties = {
    isPrimaryDomain: false,
    isExtern: false,
    isTel: false,
    isMail: false,
    isProxy: false,
    isDeep: false,
    isQuery: false,
    isError: false,
    isPDF: false,
    href: url,
    parsedUrl: null
  };
  if (encodedUrl.startsWith("mailto:") || encodedUrl.startsWith("tel:")) {
    urlProperties.isMail = encodedUrl.startsWith("mailto:");
    urlProperties.isTel = encodedUrl.startsWith("tel:");
    urlProperties.href = url;
  }
  if (getFileTypeFromFileName(url) === "pdf" || url.includes("/tools/downloads/")) {
    urlProperties.isPDF = true;
  }
  try {
    let parsedCurrentUrl;
    if (encodedUrl.startsWith("/") || encodedUrl.startsWith("#") || encodedUrl.startsWith("?")) {
      parsedCurrentUrl = new URL(encodedUrl, baseUrl);
    } else if (encodedUrl.startsWith("www.")) {
      parsedCurrentUrl = new URL(encodedUrl, baseUrl);
    } else {
      parsedCurrentUrl = new URL(encodedUrl);
    }
    const currentDomain = parsedCurrentUrl.hostname.split(".");
    const localDomain = hostname.split(".");
    const currentPrimaryDomain = currentDomain.length >= 2 ? currentDomain.slice(-2).join(".") : currentDomain.join(".");
    const localPrimaryDomain = localDomain.length > 2 ? localDomain.slice(-2).join(".") : localDomain.join(".");
    urlProperties.parsedUrl = parsedCurrentUrl;
    urlProperties.isPrimaryDomain = currentPrimaryDomain === localPrimaryDomain;
    urlProperties.isExtern = hostname !== parsedCurrentUrl.hostname && !/^\//.test(url);
    urlProperties.isProxy = ["/tools/downloads/", "/tools/export/"].includes(
      parsedCurrentUrl.pathname
    );
    urlProperties.isDeep = /^#/.test(url);
    urlProperties.isQuery = /^\?/.test(url);
    return urlProperties;
  } catch (e) {
    urlProperties.isError = true;
    return urlProperties;
  }
};
export const getLinkAriaLabel = (title, url) => {
  const urlType = parseUrlData(url);
  const { isPDF, parsedUrl } = urlType;
  const domain = parsedUrl?.hostname;
  let ariaLabel = title;
  if (urlType.isMail) {
    ariaLabel = `E-Mail: ${title}`;
  } else if (urlType.isTel) {
    ariaLabel = `Telefon: ${title}`;
  } else if (urlType.isExtern) {
    ariaLabel += `, Link zu: ${domain} aufrufen`;
  } else if (isPDF) {
    ariaLabel += `, (PDF)`;
  }
  return ariaLabel;
};
